// extracted by mini-css-extract-plugin
module.exports = {"floating":"_3426c5","floatingContent":"_94d886","touch":"_d63299","enter":"_931bcc","leave":"_58f8e9","from":"_5b6abe"};